<template>
	<div class="dragger" @dragstart="dragstart" draggable="true">
		<slot/>
	</div>
</template>
<script>
	export default {
		name:"dragger",
		props:["context"],
		methods:{
			dragstart(){
				event.dataTransfer.setData('data', JSON.stringify(this.context));
			}
		},
		data(){
			return {
				item:"value"
			}
		}
	}
</script>
<style scoped>
	.dragger{
		display: inline-block;
	}
</style>